import React from 'react';
import _ from 'lodash';
import BottomScrollListener from 'react-bottom-scroll-listener';
import { WithProductsSearch } from '../WithProductsSearch';
import { If } from '../../Components';
import { Products } from './Products';
import { ProductTitleForClusters, ProductTitle } from './ProductTitle';

export const SearchProducts = ({
  setPage,
  page,
  tischOffensiveId,
  defaultSearch,
  onSearch,
  clusters,
  genre,
}) => (
    <WithProductsSearch
      clusters={clusters}
      genre={genre}
      key={defaultSearch}
      defaultSearch={defaultSearch || ''}
      page={page}
      onSearch={onSearch}>
      {({ products }) => (
          <>
            <If condition={!!clusters || genre}>
              {() => (
                <ProductTitleForClusters genre={genre} clusters={clusters} />
              )}
            </If>
            <If condition={!!defaultSearch}>
              {() => (
                <ProductTitle description={`Results for : ${defaultSearch}`} />
              )}
            </If>
            <Products
              tischOffensiveId={tischOffensiveId}
              products={_.get(products, 'data')}
            />
            <BottomScrollListener onBottom={() => setPage(page + 1)} />
          </>
      )}
    </WithProductsSearch>
);
